"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var Section_1 = __importDefault(require("./Section"));
var Question = function (props) {
    var _a, _b, _c, _d;
    var theme = core_1.useTheme();
    var spacing = (_a = props.spacing) !== null && _a !== void 0 ? _a : 2;
    var section = (_b = props.section) !== null && _b !== void 0 ? _b : false;
    var showIf = (_c = props.showIf) !== null && _c !== void 0 ? _c : true;
    var style = (_d = props.style) !== null && _d !== void 0 ? _d : {
        flexDirection: "column",
        display: "flex",
        marginTop: theme.spacing(spacing),
        gap: theme.spacing(spacing * 1),
    };
    if (!section) {
        return react_1.default.createElement("div", null, showIf && react_1.default.createElement("div", { style: style }, props.children));
    }
    else {
        return (react_1.default.createElement("div", null, showIf && (react_1.default.createElement(Section_1.default, __assign({}, props.sectionProps),
            react_1.default.createElement("div", { style: style }, props.children)))));
    }
};
exports.default = Question;
